/**
 * Basic Content Block component (used for Overview or general sections)
 */

import React from "react"
import parse from "html-react-parser"
import { kebabCase } from "lodash"
import { Link } from "gatsby"
import CopyLinkButton from "./copy-link-button"
import { HiChevronRight } from "react-icons/hi"

const BasicContentBlock = ({ props, annualReport, index }) => {
  const { heading, leadContent, content, button, contentWidth, includeInStickyMenu, background, linkList } = props
  return (
    <section
      key={heading || includeInStickyMenu?.menuTitle}
      className={`section ${annualReport === "2024" ? "p-section relative" : background === 'logo' ? "p-section relative shadow-down-soft" : "m-section"}`}
    >
      <div

        className={`${annualReport === "2024" ? "absolute -z-10 w-2/3 md:w-1/3 lg:w-1/4 aspect-square border border-ar24-lavender rounded-full -top-[10%] lg:-top-1/4 -left-[5%]" : background === 'logo' ? "absolute inset-0 bg-page-circle-logo bg-no-repeat bg-[length:50%] opacity-20" : ""}`}
      ></div>
      <div className="relative container">
        <div className={`relative mx-auto  ${annualReport === "2024" ? "grid grid-cols-1 lg:grid-cols-5 gap-6 xl:gap-16 max-w-7xl mx-auto" : `lg:w-${contentWidth}/12 ${background === 'logo' ? "bg-gray-200 py-5 px-6" : ""}`} `}>
          <div className={`group-copy-link group grid grid-cols-1 justify-start ${annualReport === "2024" ? "lg:col-span-2": ""}`}>
            {heading ? (
              <>
                <h2
                  id={kebabCase(heading).replace(/[0-9]/g, "")}
                  className={`anchor-heading mb-4 ${annualReport === "2024" ? "max-w-lg text-2xl md:text-3xl md:leading-tight lg:text-4xl xl:text-5xl leading-tight font-black font-inter text-ar24-blue" : ""}`}
                  data-sal="slide-up"
                  data-sal-delay="300"
                >
                  {heading}
                </h2>
                <CopyLinkButton heading={heading} />
              </>
            ) : includeInStickyMenu?.menuTitle ? (
              <div id={kebabCase(includeInStickyMenu.menuTitle) || ""}>
                <CopyLinkButton heading={includeInStickyMenu.menuTitle} />
              </div>
            ) : null}
          </div>
          <div className={`${annualReport === "2024" ? `lg:col-span-3 p-0 lg:p-4 xl:p-6 rounded-2xl -mx-6 sm:mx-0 shadow-spread bg-white ${index === 0 ? "lg:-mt-32" : ""}` : ""}`}>
            <div className={`${annualReport === "2024" ? `p-6 sm:p-8 xl:p-16  mx-auto rounded-2xl border border-ar24-blue/20 ` : ""}`}>
              {leadContent ? (
                <div
                  className="lead-content parsed-content mb-4"
                  data-sal="fade-in"
                  data-sal-delay="300"
                >
                  {parse(leadContent)}
                </div>
              ) : null}
              {content ? (
                <div
                  className="parsed-content mb-4"
                  data-sal="fade-in"
                  data-sal-delay="300"
                >
                  {parse(content)}
                </div>
              ) : null}
              {linkList ? (
                <ul className="masonry masonry-cols-2 -mt-1">
                  {linkList.map(({ link }) => {
                    return (
                      <>
                        {link?.title && link?.url ? <li key={link.title} className="py-1">
                          <Link to={link.url} className="a btn-text text-body h4 inline-flex items-center justify-between group">{link.title} <HiChevronRight className="ml-1 transition group-hover:translate-x-1" /></Link>
                        </li> : null}
                      </>
                    )
                  })}
                </ul>
              ) : null}

              {button ? (
                <div className="mb-4">
                  <div
                    className="inline-flex rounded-md shadow"
                    data-sal="flip-up"
                    data-sal-delay="300"
                  >
                    {button.target ? (
                      <a
                        href={button.url}
                        className="btn btn-blue"
                        target={button.target}
                        rel="noopener noreferrer"
                      >
                        {button.title}
                      </a>
                    ) : (
                      <Link className="btn btn-blue" to={button.url}>
                        {button.title}
                      </Link>
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BasicContentBlock
